<template>
	<tabbed-page-layout class="accounting" title="Regnskab" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>